import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetStaffTenureDistributionRequestDtoSchema = z.object({
  facilityId: z.number(),
  comparisonSet: z.enum(['INTERNAL', 'COMP']).optional(),
  from: z.string().optional(),
  to: z.string().optional(),
});

const GetStaffTenureDistributionResponseDtoSchema = z.array(
  z.object({
    currentValue: z.number().nullable(),
    marketAverage: z.number().nullable(),
    range: z.string(),
  })
);

export type GetStaffTenureDistributionRequestDto = z.infer<
  typeof _GetStaffTenureDistributionRequestDtoSchema
>;
export type GetStaffTenureDistributionResponseDto = z.infer<
  typeof GetStaffTenureDistributionResponseDtoSchema
>;

export const getStaffTenureDistribution = async (
  params: GetStaffTenureDistributionRequestDto,
  config?: AxiosRequestConfig<GetStaffTenureDistributionRequestDto>
) => {
  const { facilityId, ...restParams } = params;

  return api
    .get(
      `/market-intelligence/facilities/${facilityId}/staff-tenure-distribution`,
      {
        params: restParams,
        ...config,
      }
    )
    .then(responseContract(GetStaffTenureDistributionResponseDtoSchema));
};
